const ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
export const baseURL: string = "https://jjcharter-api-bjd7aaaafmatawd2.centralus-01.azurewebsites.net/api/v1/";
const appName: string = "VELOXCHARTER";
const appId: string = "10"

export { ticketBaseURL, appName, appId };
